import React, { Fragment, useRef, useState } from "react";
import "./Toggle.css";
import { Formik, Form, Field } from "formik";
import Swal from "sweetalert2";
import "animate.css";
import * as Yup from "yup";
import GoodsToggle from "./SettingsToggle";
import { useNavigate } from "react-router-dom";
import { UserSetting } from "./UserSetting";
import { CompanySetting } from "./CompanySetting";
function SettingsDashboard() {
  const [Toggle, setToggle] = useState("User");
  const Navigate = useNavigate();

  const toggleHandler = () => {
    if (Toggle == "Company") {
      setToggle("User");
    } else {
      setToggle("Company");
    }
  };


  return (
    <>
     <div className="flex flex-col container max-w-5xl mt-2 mb-5 xl:max-w-7xl">
        <div className="flex flex-row justify-between w-full items-center">
          <div className="flex flex-row items-center">
            <div>
              {Toggle == "User" ? (
                <>
                  {" "}
                  <h2 className="font-Montserrat text-xl font-bold text-black">
                    Settings
                  </h2>
                  <div className="border-b-2 border-blue-200 w-16"></div>
                </>
              ) : (
                <>
                  {" "}
                  <h2 className="font-Montserrat text-xl font-bold text-black">
                  Settings
                  </h2>
                  <div className="border-b-2 border-blue-200 w-16"></div>
                </>
              )}
            </div>
          </div>
          
        </div>
        <GoodsToggle ToggleHandler={toggleHandler} Toggle={Toggle} />
      </div>
      <div className="flex flex-col max-w-4xl mt-2 mb-5  xl:max-w-7xl">
       {Toggle == "User" ?<UserSetting/> : <CompanySetting />}
       </div>
    </>
  );
}

export default SettingsDashboard;
